import React from "react";
import allegroLogo from "../../images/desktop/AmazonAllegro.svg";
import { useNavigate } from "react-router-dom";
import Masthead, {
  MastheadTitle,
  MastheadMenuButton,
} from "@amzn/meridian/masthead";
import { useSideMenuContext } from "../..";
import { HOME } from "../..";
import LanguagePicker from "../languagePicker";
import BusinessUnitSelect from "src/components/shared/components/header/businessUnitSelect";
import { isDevEnv } from "src/components/shared/utils/utils";

const Header = () => {
  const navigate = useNavigate();

  const { sideMenuOpen, setSideMenuOpen } = useSideMenuContext();

  const handleHomeIconClick = (path) => {
    navigate(HOME);
    setSideMenuOpen(false);
  };

  return (
    <Masthead size="small">
      <MastheadMenuButton
        onClick={() => setSideMenuOpen(!sideMenuOpen)}
        open={true}
      />
      <MastheadTitle>
        <img
          src={allegroLogo}
          onClick={() => handleHomeIconClick(HOME)}
          width="61"
          height="24"
          alt=""
        />
      </MastheadTitle>
      {isDevEnv() && <BusinessUnitSelect></BusinessUnitSelect>}
      <LanguagePicker></LanguagePicker>
    </Masthead>
  );
};

export default Header;
